/** Where the app runs: a browser tab (or installed web app) or the Tauri desktop shell. */
export const RuntimeEnv = {
  Browser: 'browser',
  Tauri: 'tauri',
} as const;
export type RuntimeEnv = (typeof RuntimeEnv)[keyof typeof RuntimeEnv];

/** Tauri injects `__TAURI_INTERNALS__` into the page of its web view. */
export function detectRuntimeEnv(): RuntimeEnv {
  return typeof window !== 'undefined' && '__TAURI_INTERNALS__' in window
    ? RuntimeEnv.Tauri
    : RuntimeEnv.Browser;
}
